module.exports = __webpack_public_path__ + "static/media/spice_hero_tablet.7a125ac9.jpg";